/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import apiService from '@services/apiService';

const CLEAR_ACL_DETAILS = 'CLEAR_ACL_DETAILS';
const CLEAR_ACL_ACTION_LOADING_STATUSES = 'CLEAR_ACL_ACTION_LOADING_STATUSES';
const CLEAR_ACL_ACTIONS_COMPLETED = 'CLEAR_ACL_ACTIONS_COMPLETED';

const GET_ACL_DETAILS = 'GET_ACL_DETAILS';
const GET_ACL_DETAILS_FAIL = 'GET_ACL_DETAILS_FAIL';
const GET_ACL_DETAILS_SUCCESS = 'GET_ACL_DETAILS_SUCCESS';

const GET_MAIN_ACL_DETAILS = 'GET_MAIN_ACL_DETAILS';
const GET_MAIN_ACL_DETAILS_FAIL = 'GET_MAIN_ACL_DETAILS_FAIL';
const GET_MAIN_ACL_DETAILS_SUCCESS = 'GET_MAIN_ACL_DETAILS_SUCCESS';

const FORM_SUBMITTED = 'FORM_SUBMITTED';

const SET_ACL_ACTION_LOADING_STATUS = 'SET_ACL_ACTION_LOADING';
const SET_ACL_ACTIONS_COMPLETED = ' SET_ACL_ACTIONS_COMPLETED';

const initialState = {
  fieldPermissions: {},
  formActions: {},
  aclString: '',
  mainActions: {},
  formPermissions: {},
  pagePermissions: {},
  error: false,
  loading: false,
  actionLoadingStatuses: {},
  actionsComplete: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ACL_DETAILS:
    case FORM_SUBMITTED:
      return {
        // reset all except mainActions and aclString since they need to stay active at all times
        ...initialState,
        aclString: state.aclString,
        mainActions: state.mainActions,
      };
    case CLEAR_ACL_ACTION_LOADING_STATUSES: // clearAll should not be used, in favor of targeted manip
      return {
        ...state,
        actionLoadingStatuses: {},
      };
    case CLEAR_ACL_ACTIONS_COMPLETED:
      return {
        ...state,
        actionsComplete: {},
      };
    case GET_ACL_DETAILS:
    case GET_MAIN_ACL_DETAILS:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case GET_ACL_DETAILS_SUCCESS:
      return {
        ...state,
        ...action.payload.aclDetails,
        error: false,
        loading: false,
      };
    case GET_MAIN_ACL_DETAILS_SUCCESS:
      return {
        ...state,
        mainActions: action.payload.aclDetails.formActions,
        aclString: action.payload.aclDetails.aclString,
        error: false,
        loading: false,
      };
    case GET_ACL_DETAILS_FAIL:
    case GET_MAIN_ACL_DETAILS_FAIL:
      return {
        ...state,
        error: true,
        loading: false,
      };
    case SET_ACL_ACTION_LOADING_STATUS:
      return {
        ...state,
        actionLoadingStatuses: { ...state.actionLoadingStatuses, ...action.payload.aclLoadingActions },
      };
    case SET_ACL_ACTIONS_COMPLETED:
      return {
        ...state,
        actionsComplete: { ...state.actionsComplete, ...action.payload.aclComplete },
      };
    default:
      return state;
  }
};

const clearAclDetails = () => async dispatch => {
  dispatch({ type: CLEAR_ACL_DETAILS });
};

const clearAclLoadingStatuses = () => async dispatch => {
  dispatch({ type: CLEAR_ACL_ACTION_LOADING_STATUSES });
};

const clearAclCompleted = () => async dispatch => {
  dispatch({ type: CLEAR_ACL_ACTIONS_COMPLETED });
};

const getAclDetails = (resourceType, requestDetails) => async dispatch => {
  dispatch({ type: GET_ACL_DETAILS });
  try {
    const aclDetails = await apiService.Acl.GetAclDetails(resourceType, requestDetails);
    const aclResource = requestDetails.formName ?? requestDetails.formname;
    const aclActionType = requestDetails.action ?? requestDetails.Action;
    const actionName = `${aclResource}${aclActionType}`;
    const aclComplete = { [actionName]: true };
    const aclLoadingActions = { [actionName]: false };
    dispatch({
      type: GET_ACL_DETAILS_SUCCESS,
      payload: { aclDetails },
    });
    dispatch({
      type: SET_ACL_ACTIONS_COMPLETED,
      payload: { aclComplete },
    });
    dispatch({
      type: SET_ACL_ACTION_LOADING_STATUS,
      payload: { aclLoadingActions },
    });
  } catch (err) {
    console.error('Error: ACL getAclDetails: ', err);
    dispatch({ type: GET_ACL_DETAILS_FAIL });
  }
};

const getMainAclDetails = (resourceType, requestDetails) => async dispatch => {
  dispatch({ type: GET_MAIN_ACL_DETAILS });
  try {
    const aclDetails = await apiService.Acl.GetAclDetails(resourceType, requestDetails);
    dispatch({
      type: GET_MAIN_ACL_DETAILS_SUCCESS,
      payload: { aclDetails },
    });
  } catch (err) {
    console.error('Error: ACL getMainAclDetails: ', err);
    dispatch({ type: GET_MAIN_ACL_DETAILS_FAIL });
  }
};

const setMultiLoadingStatus = aclLoadingActions => async dispatch => {
  dispatch({
    type: SET_ACL_ACTION_LOADING_STATUS,
    payload: { aclLoadingActions },
  });
};

const setActionCompleted = aclComplete => async dispatch => {
  dispatch({
    type: SET_ACL_ACTIONS_COMPLETED,
    payload: { aclComplete },
  });
};

export {
  clearAclDetails,
  clearAclLoadingStatuses,
  clearAclCompleted,
  getAclDetails,
  getMainAclDetails,
  setActionCompleted,
  setMultiLoadingStatus,
};
